import {Component, OnInit} from '@angular/core';
import {Session} from '../../../domain/session';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ConfirmationDialogComponent} from '../../../component/confirmation-dialog/confirmation-dialog.component';
import {DeviationDefinition} from '../../../domain/deviation-definition';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {PopupDialogBase} from '../../../component/popup-dialog-base';
import {UUID} from 'angular2-uuid';
import {Router} from '@angular/router';
import {MessageService} from '../../../component/message.service';
import {RequestExecutor} from '../../../util/request-executor';

@Component({
  selector: 'app-deviation-definition-edit',
  templateUrl: './deviation-definition-edit.component.html',
  styleUrls: ['./deviation-definition-edit.component.css'],
  standalone: false
})
export class DeviationDefinitionEditComponent extends PopupDialogBase implements OnInit {
  formGroup: UntypedFormGroup;

  definition: DeviationDefinition;
  saving: boolean;
  deleting: boolean;

  deleteConfirmDialogRef: MatDialogRef<ConfirmationDialogComponent>;

  constructor(
    formBuilder: UntypedFormBuilder,
    private request: RequestExecutor,
    private session: Session,
    private dialog: MatDialog,
    private router: Router,
    private messageService: MessageService
  ) {
    super();

    this.formGroup = formBuilder.group({
      Name: ['', Validators.required],
      Type: ['', Validators.required],
      Context: [''],
      CommentEnabled: [false],
      ImagesEnabled: [false]
    });
  }

  ngOnInit() {
    if (!this.isNewDefinition()) {
      this.formGroup.setValue(
        {
          Name: this.definition.Name.NO,
          Type: this.definition.Type,
          Context: this.definition.Context,
          ImagesEnabled: this.definition.ImagesEnabled,
          CommentEnabled: this.definition.CommentEnabled
        });
    }
  }

  save() {
    Object.keys(this.formGroup.controls).map((controlName) => {
      this.formGroup.get(controlName).markAsTouched({onlySelf: true});
    });

    if (this.formGroup.status !== 'INVALID') {
      if (this.isNewDefinition()) {
        this.definition.Id = UUID.UUID();
        this.definition.CompanyId = this.session.getCompanyId();
      }

      this.definition.Name = {NO: this.formGroup.value.Name};
      this.definition.Type = this.formGroup.value.Type;
      this.definition.Context = this.formGroup.value.Context;
      this.definition.CommentEnabled = this.formGroup.value.CommentEnabled;
      this.definition.ImagesEnabled = this.formGroup.value.ImagesEnabled;
      this.definition.Finish = false;
      this.definition.Active = true;

      this.saving = true;

      this.request.post('/deviation/definition', this.definition)
        .then(() => {
          this.saving = false;

          this.close();
        })
        .catch(error => {
          if (error.status == 401) {
            this.router.navigate(['login']);
          } else {
            this.messageService.showErrorSnackBar(`Kunne ikke lagre avviksårsak (${error.status})`);
          }
        })
        .finally(() => this.saving = false);
    }
  }

  isNewDefinition() {
    return this.definition.Id == null;
  }

  deleteDefinition() {
    this.deleteConfirmDialogRef = this.dialog.open(ConfirmationDialogComponent);

    this.deleteConfirmDialogRef.componentInstance.title = 'Bekreft sletting';
    this.deleteConfirmDialogRef.componentInstance.description = 'Vil du slette avviksårsaken?';

    this.deleteConfirmDialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.request.delete('/deviation/definition', {id: this.definition.Id})
          .then(() => {
            this.deleting = false;

            this.close();
          })
          .catch(error => {
            if (error.status == 401) {
              this.router.navigate(['login']);
            } else {
              this.messageService.showErrorSnackBar(`Kunne ikke slette avviksårsaken (${error.status})`);
            }
          })
          .finally(() => this.deleting = false);
      }
    });
  }

  cancel() {
    this.close();
  }
}
